import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/next-frontend/src/components/pages/home/blog/BlogPage.js");
